import { combineReducers } from "redux";
import loaderReducer from "./common/loaderReducer";
import globalsReducer from "./common/globalsReducer";
import userReducer from "./user/userReducer";
import eventReducer from "./event/eventReducer";
import cmsReducer from "./cms/cmsReducer";

const rootReducer = combineReducers({
  loader: loaderReducer,
  user: userReducer,
  global: globalsReducer,
  event: eventReducer,
  cms: cmsReducer,
});

export default rootReducer;
